export default __webpack_public_path__ + "static/media/reward-img-1.265812a4.png";